<template>
  <div class="  " v-if="kontakt">
    <div class="col fullheight map"
         :style="{ backgroundImage: `url(${kontakt._embedded['wp:featuredmedia']['0'].source_url})` }"></div>
    <!--        <transition @appear="enterKontakt">-->
    <div class="col-60 col-md-41 kontakt">
      <div class="content">
        <div>
          <h1>Kontakt</h1>
        </div>
        <div class="row justify-content-center">
          <div class="col-60 col-md-29">
            <h4 v-html="kontakt.acf.name"></h4>
            <div v-html="kontakt.acf.adresse"></div>
          </div>
          <div class="col-60 col-md-29">
            <div>
                Tel.
              <a href="tel:+493518588137">


                <span v-html="kontakt.acf.telefon"></span>
              </a>
            </div>

            <div>
              E-Mail:
              <a :href="'mailto:'+kontakt.acf.email">

              <span v-html="kontakt.acf.email"></span>

              </a>
            </div>
          </div>
        </div>
        <Blocks :blocks="kontakt.acf.zeile" class="kontaktblock"></Blocks>
        <h3>Anfrage</h3>


        <Formular></Formular>

        <!--                    <h3> Ansprechpartner</h3>-->
        <!--                    <div class="row">-->
        <!--                        <div class="col-30 mitarbeiter" v-for="t in team">-->
        <!--                            <div class="row" style="margin-bottom: 20px ;">-->
        <!--                                <div style="max-width: 150px;" class="pic col" v-if="t._embedded">-->
        <!--                                    <img style="width: 100%;" :src="t._embedded['wp:featuredmedia']['0'].source_url"-->
        <!--                                         alt="">-->
        <!--                                </div>-->
        <!--                                <div style="" class="info col">-->
        <!--                                    <div class="h4" v-html="t.title.rendered">{{}}</div>-->
        <!--                                    <div class="job" v-html="t.acf.job">{{}}</div>-->
        <!--                                    <div v-html="t.acf.email">{{t.acf.email}}</div>-->
        <!--                                    <div>Tel. {{t.acf.telefon}}</div>-->
        <!--                                </div>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                    </div>-->
      </div>
    </div>
    <!--        </transition>-->
  </div>
</template>
<script>
import store from '@/store'
import Velocity from "velocity-animate";
import Formular from '@/components/Formular.vue'
import Blocks from '@/components/Blocks/Blocks.vue'

export default {
  Velocity,
  store,
  data() {
    return {
      bg: 'src/assets/11d308559fd165ee5ed8cbe04228ffb9.png'
    }
  },
  components: {Formular, Blocks},
  created: function () {
    store.dispatch('getTeam');
  },
  name: "Team",
  mounted() {
    document.body.classList.add('nooverflow')
  },
  beforeDestroy() {

  },
  computed: {
    kontakt: () => store.state.pages.filter(p => p.slug === 'kontakt')[0],
    pages: () => store.state.pages,
    team: () => store.state.team,
  },
  methods: {
    enterKontakt(el, done) {
      el.velocity({
        transform: ['translateX(0)', 'translateX(-100%)']
      })
    },
  }
}
</script>
<style scoped lang="scss">
a {
  color: $zzcolor;

  &:hover {
    font-weight: 600;
    color: $zzcolor;
  }
}



.kontakt {
  background: #f8f8f8;
  @include mobile {
    background: transparent;
    margin-top: 0;
    padding-bottom: 300px;
    top: 0;
    padding-top: 300px;
    transform: translateX(0) !important;
  }
  position: absolute;
  top: 48px;
  overflow-y: auto;
  overflow-x: hidden;
  transform: translateX(100%);
  /*position: relative;*/
  right: 0;
  /*top: 0;*/
  max-height: 100vh;
  padding-bottom: 100px;

  .content {
    margin-top: 50px;
    padding: 0 10% 50px;

    @include mobile {
      margin-top: 0;
      padding-top: 50px;
      background-color: #f8f8f8;
    }
  }
}

.map {
  /*width: 75%;*/
  background-position: center center;
  background-size: cover;
  @include mobile {
    background-position: center -100px;
    width: 100% !important;
    top: 72px;
    position: relative;
  }
}

.job { //styleName: <p> - copy BIG;
  color: $zzcolor;
  font-size: 18px;
  font-style: normal;
  font-weight: 300;

  letter-spacing: 0.02em;
  text-align: left;
}
</style>
